import {Component, DestroyRef, OnInit, ViewChild} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FormsModule} from '@angular/forms';
import {KENDO_INPUTS} from '@progress/kendo-angular-inputs';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';

import {GrilleRechercheComponent} from '../../../../../val-ammon-composants/val-ammon-search-lib/src/public-api';
import {BarreMenusComponent, DonneesMenuItem, DonneesColonneBoutonIconeClick, BoiteDialogueGeneriqueComponent, SimplePanelComponent, BoiteDialogueMessagesComponent, ControleConteneurComponent} from '../../../../../val-ammon-composants/val-composants-lib/src/public-api';
import {parametresClient} from '../../../../../val-definitions-communes-lib/src/public-api';
import {EFactParametragesService} from '../val-efact-parametrages.service';
import {RetournerParametrageClientResultat} from '../RetournerParametrageClientResultat';
import {GererHabilitationsMenuItems, PermissionsService} from '../../../../../val-ammon-permissions/val-permissions-lib/src/public-api';
import {RechercherComplementComptableBt30Component} from '../rechercher-complement-comptable-bt30/rechercher-complement-comptable-bt30.component';
import {ValApiResultat} from '../../../../../val-ammon-services/val-services-communs-lib/src/public-api';
import {AeFCommandeFacture, AeFCompleterPiecesJointesFactureAchatResultat, AeFCreerPieceAchatFacturesAchatResultat, AeFImporterFacturesAchatClientResultat, AeFInitialiserSaisieRefCommandeFactureAchatParametres, AeFInitialiserSaisieRefCommandeFactureAchatResultat, AeFMettreAJourRefCommandeFactureAchatParametres, AeFRapprocherFactureDossierFacturesAchatResultat, AeFTransfererDocumentsFacturesAchatResultat, EFactTraitementService} from '../../../../../val-ammon-services/val-services-efact-lib/src/public-api';
import {VueFactureAchatFicheComponent} from './vue-facture-achat/vue-facture-achat-fiche/vue-facture-achat-fiche.component';
import {MettreAJourStatutFacturesAchatComponent} from "./mettre-a-jour-statut-factures-achat/mettre-a-jour-statut-factures-achat.component";
import {SynchroniserCyclesViesFacturesAchatComponent} from './synchroniser-cycles-vies-factures-achat/synchroniser-cycles-vies-factures-achat.component';
import {RapprocherCommandeFacturesAchatComponent} from "./rapprocher-commande-factures-achat/rapprocher-commande-factures-achat.component";
import {DetailTransfertFactureAchat, LogsTransfertFacturesAchatComponent} from "./logs-transfert-factures-achat/logs-transfert-factures-achat.component";
import {ActiverDesactiverFacturesAchatComponent} from "./activer-desactiver-factures-achat/activer-desactiver-factures-achat.component";
import {RefuserFacturesAchatComponent} from "./refuser-factures-achat/refuser-factures-achat.component";
import {StatutsAEnvoyerFacturesAchatComponent} from "./statuts-a-envoyer-factures-achat/statuts-a-envoyer-factures-achat.component";
import {CorbeilleGedFacturesAchatComponent} from "./corbeille-ged-factures-achat/corbeille-ged-factures-achat.component";

//Clés de traduction des titres des trois traitements de transfert vers le back-office — repris à
//l’identique dans la fenêtre de logs, dans les boîtes de message et dans les libellés de
//dictionnaire des boutons. La traduction se fait à l’usage, dans la langue active.
const c_TitreTransfererDocuments      = "achat.recherche.transferer-documents.titre";
const c_TitreCreerPieceAchat          = "achat.recherche.creer-piece-achat.titre";
//L’objet rapproché est nommé : « Rapprocher les commandes » existe déjà sur la même grille, et
//porte sur la commande, pas sur la pièce d’achat (SU #118217, libellé revu au SU #118452).
const c_TitreRapprocherFactureDossier = "achat.recherche.rapprocher-facture-dossier.titre";

//Dico « Corbeille GED (envoyer / retirer) », qui habilite les deux gestes d’affectation manuelle à
//une corbeille GED (SU #120249)
const c_DicoCorbeilleGed = "F2C9ADFE-A801-42FB-995A-1A56F2B7AFCE";

//Composant vue facture achat recherche
@Component (
{
  selector: 'val-vue-facture-achat-recherche',
  imports: 
  [
    FormsModule,
    KENDO_INPUTS,
    BarreMenusComponent,
    GrilleRechercheComponent,
    BoiteDialogueGeneriqueComponent,
    SimplePanelComponent,
    RechercherComplementComptableBt30Component,
    VueFactureAchatFicheComponent,
    BoiteDialogueMessagesComponent,
    ControleConteneurComponent,
    MettreAJourStatutFacturesAchatComponent,
    SynchroniserCyclesViesFacturesAchatComponent,
    RapprocherCommandeFacturesAchatComponent,
    LogsTransfertFacturesAchatComponent,
    ActiverDesactiverFacturesAchatComponent,
    RefuserFacturesAchatComponent,
    StatutsAEnvoyerFacturesAchatComponent,
    CorbeilleGedFacturesAchatComponent,
    TranslocoPipe
  ],
  templateUrl: './vue-facture-achat-recherche.component.html',
  styleUrl: './vue-facture-achat-recherche.component.scss'
})
export class VueFactureAchatRechercheComponent implements OnInit 
{
  //Création
  //  Paramètres
  //    permissionsService        : Service permission
  //    eFactTraitementService    : Service e-Facture
  //    eFactParametragesService  : Service de paramétrage e-Facture
  //    translocoService          : Service de traduction
  //    destroyRef                : Référence de destruction du composant
  constructor (private permissionsService: PermissionsService, private eFactTraitementService: EFactTraitementService,
               private eFactParametragesService: EFactParametragesService, private translocoService: TranslocoService,
               private destroyRef: DestroyRef)
  {
    this.menuItems = [];
    this.menuItemsSimpleSelection = [];
    this.menuItemsMultipleSelection = [];
    this.menuItemsCorbeilleGed = [];
    this.lignesRapportImportation = [];
    this.referenceCommande = "";
    this.donneesEditionReferenceCommande = new DonneesEditionReferenceCommande ();
    this.cheminFicheFactureBo = "";
  }
  
  //Grille de recherche
  @ViewChild ("grilleRecherche")
  public grilleRecherche!: GrilleRechercheComponent;

  //Boîte de dialogue
  @ViewChild ("boiteDialogue")
  public boiteDialogue!: BoiteDialogueGeneriqueComponent<void>;

  //Traitement de recherche des compléments comptable
  @ViewChild ("rechercherComplementComptableBt30")
  public rechercherComplementComptableBt30!: RechercherComplementComptableBt30Component;
  
  //Vue Achat
  @ViewChild("factureAchatFiche")
  public factureAchatFiche!: VueFactureAchatFicheComponent;

  //Boîte de dialogue messages
  @ViewChild ("boiteDialogueMessages")
  public boiteDialogueMessages!: BoiteDialogueMessagesComponent;

  //Boite de dialogue d’édition de la référence de commande
  @ViewChild ("editionReferenceCommande")
  public editionReferenceCommande!: BoiteDialogueGeneriqueComponent<DonneesEditionReferenceCommande>;

  //Boîte de dialogue de sélection du statut
  @ViewChild ("mettreAJourStatutFacturesAchat")
  public mettreAJourStatutFacturesAchat!: MettreAJourStatutFacturesAchatComponent;

  //Traitement de synchronisation des cycles de vies
  @ViewChild ("synchroniserCyclesViesFacturesAchat")
  public synchroniserCyclesViesFacturesAchat!: SynchroniserCyclesViesFacturesAchatComponent;

  //Traitement de rapprochement de commande
  @ViewChild ("rapprocherCommandeFacturesAchat")
  public rapprocherCommandeFacturesAchat!: RapprocherCommandeFacturesAchatComponent;

  //Fenêtre de logs des traitements de transfert des factures d’achat
  @ViewChild ("logsTransfertFacturesAchat")
  public logsTransfertFacturesAchat!: LogsTransfertFacturesAchatComponent;

  //Traitement d’activation / désactivation des factures d’achat
  @ViewChild ("activerDesactiverFacturesAchat")
  public activerDesactiverFacturesAchat!: ActiverDesactiverFacturesAchatComponent;

  //Traitement de marquage « à refuser » / annulation du marquage des factures d’achat
  @ViewChild ("refuserFacturesAchat")
  public refuserFacturesAchat!: RefuserFacturesAchatComponent;

  //Traitement des statuts de cycle de vie à envoyer à la plateforme agréée
  @ViewChild ("statutsAEnvoyerFacturesAchat")
  public statutsAEnvoyerFacturesAchat!: StatutsAEnvoyerFacturesAchatComponent;

  //Traitement d’affectation des factures d’achat à une corbeille GED, et de son retrait
  @ViewChild ("corbeilleGedFacturesAchat")
  public corbeilleGedFacturesAchat!: CorbeilleGedFacturesAchatComponent;

  //Menu items
  public menuItems: DonneesMenuItem[];

  //Menu items actif sur simple sélection
  public menuItemsSimpleSelection: DonneesMenuItem[];

  //Menu items actif sur multiple sélection
  public menuItemsMultipleSelection: DonneesMenuItem[];

  //Menu items « Envoyer vers une corbeille GED » et « Retirer la corbeille de destination », dans cet ordre
  private menuItemsCorbeilleGed: DonneesMenuItem[];

  //Lignes du rapport d’importation
  public lignesRapportImportation: string[];

  //Clé de traduction du titre de la boite de dialogue de rapport — la même boite sert l’importation
  //et la complétion. Traduite dans le gabarit, pour suivre la langue active.
  public titreRapport: string = "achat.recherche.importer-factures.titre";

  //Données d’édition de la référence de commande
  public donneesEditionReferenceCommande: DonneesEditionReferenceCommande;

  //Référence commande
  public referenceCommande: string;

  //Chemin relatif de la fiche facture du back-office, paramétré par client.
  //Vide : aucun lien n’est ouvert au clic sur l’icône de la grille.
  private cheminFicheFactureBo: string;

  //Initialise le composant
  public async ngOnInit () : Promise<void>
  {
    await this.CreerMenuItems ();
    this.InitialiserMenuItems ();
    await this.RetournerParametrageClient ();
  }

  //Retourne le paramétrage e-Facture du client — ici, le chemin relatif de la fiche
  //facture du back-office. Non renseigné, le clic sur l’icône de lien ne fait rien.
  private async RetournerParametrageClient () : Promise<void>
  {
    let valApiResultat: ValApiResultat<RetournerParametrageClientResultat>;

    try
    {
      valApiResultat = await this.eFactParametragesService.RetournerParametrageClient ();

      if (valApiResultat.status === "success")
        this.cheminFicheFactureBo = valApiResultat.resultat!.cheminFicheFactureBo ?? "";
    }
    catch (erreur)
    {
    }
  }

  //Ouvre la fiche facture du back-office pour la ligne dont l’icône a été cliquée
  //  Paramètres
  //    donneesColonneBoutonIconeClick : Données de l’événement
  //  L’adresse a trois morceaux, et les trois doivent être présents : la racine du BO
  //  (paramétrée par client, CLIENT.CBACKOFFICEURL), le chemin relatif de la fiche
  //  (paramétrage e-Facture) et la référence de la pièce d’achat (le SDOSFACTURE).
  //  L’icône n’est déjà rendue que si la référence existe — la colonne BTN_ICON vaut
  //  NULL sinon —, mais les deux autres morceaux ne se contrôlent que d’ici.
  public OuvrirFicheBackOffice (donneesColonneBoutonIconeClick: DonneesColonneBoutonIconeClick) : void
  {
    let ligne: any;
    let reference: string;
    let racine: string;
    let chemin: string;

    if (donneesColonneBoutonIconeClick.champ !== "LIEN_FICHE_BO")
      return;

    racine = parametresClient.urlBackOffice.trim ();
    chemin = this.cheminFicheFactureBo.trim ();

    if (racine === "" || chemin === "")
      return;

    //La référence voyage dans la colonne technique REF_PIECE_ACHAT_LIEN, toujours
    //présente dans le SELECT : celle du script 62 est masquée par défaut, donc absente.
    ligne = this.grilleRecherche.donneesGrille.find (l => l["PK"] === donneesColonneBoutonIconeClick.identifiant);

    if (!ligne)
      return;

    reference = (ligne["REF_PIECE_ACHAT_LIEN"] ?? "").toString ().trim ();

    if (reference === "")
      return;

    window.open (`${racine.replace (/\/+$/, "")}/${chemin.replace (/^\/+/, "")}${reference}`, "_blank");
  }

  //Crée les menu items
  private async CreerMenuItems () : Promise<void> 
  {
    let menuItems: DonneesMenuItem[];
    let gererHabilitationsMenuItems: GererHabilitationsMenuItems;

    //Chaque item est déclaré en const et référencé directement dans les listes de sélection (SU
    //#118259). La forme précédente les retrouvait par `menuItems.find (… dico === …)!` sur le
    //tableau de premier niveau : dès qu’un item passe sous un parent, `find` rend `undefined`, le
    //`!` ne rattrape rien et `InitialiserMenuItems` lève « Cannot set properties of undefined ».
    //C’est la forme retenue côté Ventes (vue-facture-vente-recherche.component.ts).
    const menuItemOuvrir: DonneesMenuItem = {dico: "2CB23854-7966-4B95-A93E-39FFB8D7CFAB", iconeClass: "fas fa-external-link", action: this.Ouvrir.bind (this)};

    const menuItemImporterFactures: DonneesMenuItem = {dico: "B184477F-8F5F-47FE-A21B-66E88943821F", iconeClass: "fas fa-file-import", action: this.ImporterFactures.bind (this)};
    const menuItemCompleterPiecesJointes: DonneesMenuItem = {dico: "F745A505-6E64-48A7-9A75-E9A475AB31F7", iconeClass: "fas fa-paperclip", action: this.CompleterPiecesJointes.bind (this)};
    const menuImport: DonneesMenuItem = {dico: "905E45C8-73EE-42D7-9894-E25BD7E9FA25", iconeClass: "fas fa-download", items: [menuItemImporterFactures, menuItemCompleterPiecesJointes]};

    const menuItemSaisirStatut: DonneesMenuItem = {dico: "E7296B90-604C-470E-A9D8-317BDB4F9289", iconeClass: "fas fa-pencil-alt", action: this.OuvrirSelectionStatut.bind (this)};
    const menuItemSaisirReferenceCommande: DonneesMenuItem = {dico: "B2CE20BC-5D6E-4A98-9B4C-2DE86619E805", iconeClass: "fas fa-pencil-alt", action: this.EditerReferenceCommande.bind (this)};
    const menuItemRapprocherCommande: DonneesMenuItem = {dico: "2CAC1487-8286-43C4-9A7A-17A073F4B211", iconeClass: "fas fa-file-search", action: this.RapprocherCommandesFacturesAchat.bind (this)};
    //Affectation manuelle à une corbeille GED, et son retrait (SU #120249). Un seul dico habilite les
    //deux gestes, comme « Refuser / Annuler refus » : il est retiré après l’habilitation, voir
    //LibellerMenuItemsCorbeilleGed.
    const menuItemEnvoyerCorbeilleGed: DonneesMenuItem = {dico: c_DicoCorbeilleGed, iconeClass: "fas fa-inbox", action: this.EnvoyerCorbeilleGedFacturesAchat.bind (this)};
    const menuItemRetirerCorbeilleGed: DonneesMenuItem = {dico: c_DicoCorbeilleGed, iconeClass: "fas fa-minus-circle", action: this.RetirerCorbeilleGedFacturesAchat.bind (this)};
    const menuSaisie: DonneesMenuItem = {dico: "9672F814-DCDD-43AB-9237-4F9D33A5B926", iconeClass: "fas fa-keyboard", items: [menuItemSaisirStatut, menuItemSaisirReferenceCommande, menuItemRapprocherCommande, menuItemEnvoyerCorbeilleGed, menuItemRetirerCorbeilleGed]};

    //Les deux traitements issus du découpage du « Transmettre » mono-appel (Fonctionnalité
    //#116844). Le mot « transmettre » est réservé au cycle de vie PA/PDP : le passage vers le
    //back-office se dit « transférer ».
    const menuItemTransfererDocuments: DonneesMenuItem = {dico: "ADA44935-A55A-407E-953E-E2F017E8CA33", iconeClass: "fas fa-file-export", action: this.TransfererDocumentsFacturesAchat.bind (this)};
    const menuItemCreerPieceAchat: DonneesMenuItem = {dico: "8A83387F-C5E1-4398-B075-FF07B0CB1D29", iconeClass: "fas fa-file-invoice", action: this.CreerPieceAchatFacturesAchat.bind (this)};
    //Rapprochement seul (Fonctionnalité #118211) : le gestionnaire choisit désormais entre
    //rapprocher une facture dossier existante et créer la pièce, là où « Créer la pièce d’achat »
    //décidait seul. Ce dernier n’est pas touché, il garde son rapprochement implicite.
    const menuItemRapprocherFactureDossier: DonneesMenuItem = {dico: "4754B269-0BDA-4042-BB99-AFD9481749C7", iconeClass: "fas fa-link", action: this.RapprocherFactureDossierFacturesAchat.bind (this)};
    //L’ordre d’affichage du sous-menu vient de ce tableau, pas de la table DICO : le rapprochement
    //précède la création, parce qu’il se tente d’abord (SU #118452).
    const menuTransfertBackOffice: DonneesMenuItem = {dico: "AA27DA8F-C0C3-4D3B-B3CE-6533EF059992", iconeClass: "fas fa-exchange-alt", items: [menuItemTransfererDocuments, menuItemRapprocherFactureDossier, menuItemCreerPieceAchat]};

    const menuItemSynchroniserCyclesVies: DonneesMenuItem = {dico: "FF4BB7D7-DB5A-4CB6-90E4-C9A202E70AEE", iconeClass: "fas fa-sync", action: this.SynchroniserCyclesVies.bind (this)};
    //Neutralisation de lignes du SAS sans suppression (SU #117315) : le sens interdit est le même
    //pictogramme que celui de la colonne « Active » de la grille.
    const menuItemActiverDesactiver: DonneesMenuItem = {dico: "A607AE12-8931-4500-B303-6EB37294B945", iconeClass: "fas fa-ban", action: this.ActiverDesactiverFacturesAchat.bind (this)};
    //Marquage « à refuser » de la sélection, et son annulation (SU #117809). Le refus lui-même est
    //transmis par le job de refus automatique : ce traitement ne décide que du marquage.
    const menuItemRefuser: DonneesMenuItem = {dico: "D4E9B1C7-2A85-4F63-9E17-5C08A3B6D294", iconeClass: "fas fa-thumbs-down", action: this.RefuserFacturesAchat.bind (this)};
    //Statuts de cycle de vie calculés depuis le back-office, puis envoyés à la plateforme agréée
    //(SU #119400) : les deux temps des jobs du même nom, restreints à la sélection.
    const menuItemStatutsAEnvoyer: DonneesMenuItem = {dico: "1E780DD0-A3D6-4D6C-9881-96696DF96E2C", iconeClass: "fas fa-paper-plane", action: this.TraiterStatutsAEnvoyer.bind (this)};
    const menuCycleDeVie: DonneesMenuItem = {dico: "53E0FD5F-2BEE-4236-9851-59C821B13785", iconeClass: "fas fa-recycle", items: [menuItemSynchroniserCyclesVies, menuItemStatutsAEnvoyer, menuItemActiverDesactiver, menuItemRefuser]};

    //« Ouvrir » reste à plat : c’est le geste le plus fréquent, et il est déjà câblé sur le
    //double-clic de la grille. Les quatorze autres traitements se rangent sous quatre parents.
    menuItems = [menuItemOuvrir, menuImport, menuSaisie, menuTransfertBackOffice, menuCycleDeVie];

    this.menuItemsSimpleSelection.push (menuItemOuvrir);
    this.menuItemsSimpleSelection.push (menuItemSaisirReferenceCommande);
    //La complétion des pièces jointes porte sur une facture désignée : elle exige une sélection unique.
    this.menuItemsSimpleSelection.push (menuItemCompleterPiecesJointes);

    this.menuItemsMultipleSelection.push (menuItemSaisirStatut);
    this.menuItemsMultipleSelection.push (menuItemSynchroniserCyclesVies);
    this.menuItemsMultipleSelection.push (menuItemRapprocherCommande);
    //Les deux traitements du découpage portent désormais sur la sélection (SU #117296) : sans elle
    //ils n’ont rien à traiter, donc ils se grisent comme les trois ci-dessus. Ils ne figuraient
    //dans aucune des deux listes, et restaient donc actifs sans qu’aucune ligne soit cochée.
    this.menuItemsMultipleSelection.push (menuItemTransfererDocuments);
    this.menuItemsMultipleSelection.push (menuItemCreerPieceAchat);
    //Le rapprochement porte sur la même sélection que ses deux voisins (SU #118217) : sans ligne
    //cochée il n’a rien à rapprocher, et il se grise comme eux.
    this.menuItemsMultipleSelection.push (menuItemRapprocherFactureDossier);
    //L’activation porte sur la sélection : sans ligne cochée, elle n’a rien à basculer (SU #117315).
    this.menuItemsMultipleSelection.push (menuItemActiverDesactiver);
    //Le marquage « à refuser » porte lui aussi sur la sélection (SU #117809).
    this.menuItemsMultipleSelection.push (menuItemRefuser);
    //Le calcul et l’envoi des statuts portent sur la sélection (SU #119400).
    this.menuItemsMultipleSelection.push (menuItemStatutsAEnvoyer);
    //L’affectation à une corbeille GED et son retrait portent sur la sélection (SU #120249).
    this.menuItemsMultipleSelection.push (menuItemEnvoyerCorbeilleGed);
    this.menuItemsMultipleSelection.push (menuItemRetirerCorbeilleGed);

    gererHabilitationsMenuItems = new GererHabilitationsMenuItems (menuItems, this.permissionsService);

    this.menuItems = await gererHabilitationsMenuItems.Executer ();

    this.menuItemsCorbeilleGed = [menuItemEnvoyerCorbeilleGed, menuItemRetirerCorbeilleGed];

    this.LibellerMenuItemsCorbeilleGed ();

    //Les libellés des deux items suivent la langue active, comme ceux que traduit la barre de menus.
    this.translocoService.selectTranslation ()
      .pipe (takeUntilDestroyed (this.destroyRef))
      .subscribe (() => this.LibellerMenuItemsCorbeilleGed ());
  }

  //Libelle les deux items de la corbeille GED dans la langue active (SU #120249)
  //  Le libellé d’un item vient de son dico, et la barre de menus le traduit par ce même dico : les
  //  deux items partageant le dico de leur habilitation, ils porteraient le même libellé. Une fois
  //  l’habilitation appliquée — l’item est retiré du menu sans le droit, comme « Refuser » —, le dico
  //  n’a plus d’usage : il est retiré, et chaque item reçoit son propre libellé traduit.
  private LibellerMenuItemsCorbeilleGed () : void
  {
    const clesLibelles: string[] = ["achat.corbeille-ged.envoyer-titre", "achat.corbeille-ged.retirer-titre"];

    this.menuItemsCorbeilleGed.forEach ((menuItem, index) =>
    {
      delete menuItem.dico;

      menuItem.libelle = this.translocoService.translate (clesLibelles[index]);
    });
  }

  //Initialise le menu
  private InitialiserMenuItems () : void 
  {
    for (const menuItem of this.menuItemsSimpleSelection)
      menuItem.disabled = true;

    for (const menuItem of this.menuItemsMultipleSelection)
      menuItem.disabled = true;
  }

  //Traite le changement de sélection
  public SelectionChange () : void 
  {
    let simpleActif: boolean;
    let multipleActif: boolean;

    if (this.grilleRecherche.identifiantsSelectionnes.length > 0)
    {
      simpleActif = this.grilleRecherche.identifiantsSelectionnes.length === 1;
      multipleActif = true;
    }
    else
    {
      simpleActif = this.grilleRecherche.identifiantFocus !== null;
      multipleActif = this.grilleRecherche.identifiantFocus !== null;
    }

    for (const menuItem of this.menuItemsSimpleSelection)
      menuItem.disabled = !simpleActif;

    for (const menuItem of this.menuItemsMultipleSelection)
      menuItem.disabled = !multipleActif;
  }

  //Exécute les actions sur un double click
  public ExecuterActionsSurDoubleClick () : void
  {
    this.Ouvrir ();
  }

  //Ouvre la fiche de consultation de la facture d’achat
  private Ouvrir(): void {
    const idAchat = this.RetournerIdentifiantSelectionne();
    if (idAchat)
      this.factureAchatFiche.Ouvrir(idAchat);
  }

  //Importe les factures d’achat du client
  private async ImporterFactures () : Promise<void> 
  {
    let valApiResultat: ValApiResultat<AeFImporterFacturesAchatClientResultat>;

    this.grilleRecherche.operationEnCours = true;

    try
    {
      this.titreRapport = "achat.recherche.importer-factures.titre";

      valApiResultat = await this.eFactTraitementService.ImporterFacturesAchatClient ();

      if (valApiResultat.status === "success")
      {
        this.FormaterRapportImportation (valApiResultat.resultat!);

        if (valApiResultat.resultat!.nombreFacturesIntegrees > 0)
        {
          this.grilleRecherche.ReinitaliserRecherche ();

          await this.grilleRecherche.ExecuterRecherche ();
        }
      }
    }
    catch (erreur)
    {
    }

    this.grilleRecherche.operationEnCours = false;

    await this.boiteDialogue.Ouvrir ();
  }

  //Complète les pièces jointes de la facture d’achat sélectionnée
  //  Traitement de rattrapage : récupère auprès de la plateforme agréée les pièces jointes absentes de
  //  la facture, y compris celles portées par le flux lui-même (Factur-X, CII, UBL), et n’ajoute que
  //  ce qui manque.
  private async CompleterPiecesJointes () : Promise<void>
  {
    let identifiantFacture: string | null;
    let valApiResultat: ValApiResultat<AeFCompleterPiecesJointesFactureAchatResultat>;

    identifiantFacture = this.RetournerIdentifiantSelectionne ();

    if (!identifiantFacture)
      return;

    this.grilleRecherche.operationEnCours = true;

    try
    {
      valApiResultat = await this.eFactTraitementService.CompleterPiecesJointesFactureAchat ({identifiantFacture: identifiantFacture});

      this.FormaterRapportCompletionPiecesJointes (valApiResultat);
    }
    catch (erreur)
    {
      this.lignesRapportImportation = [this.translocoService.translate ("achat.recherche.completer-pieces-jointes.echec")];
    }

    this.grilleRecherche.operationEnCours = false;

    this.titreRapport = "achat.recherche.completer-pieces-jointes.titre";

    await this.boiteDialogue.Ouvrir ();
  }

  //Formate le rapport de complétion des pièces jointes
  //  valApiResultat : Résultat de la complétion des pièces jointes
  private FormaterRapportCompletionPiecesJointes (valApiResultat: ValApiResultat<AeFCompleterPiecesJointesFactureAchatResultat>) : void
  {
    let resultat: AeFCompleterPiecesJointesFactureAchatResultat | null;
    let lignes: string[];

    resultat = valApiResultat.resultat ?? null;

    lignes = [];

    if (resultat && resultat.reference)
      lignes.push (this.translocoService.translate ("achat.recherche.completer-pieces-jointes.facture", {reference: resultat.reference}));

    if (valApiResultat.status !== "success")
    {
      lignes.push (valApiResultat.message ? valApiResultat.message : this.translocoService.translate ("achat.recherche.completer-pieces-jointes.echec"));
    }
    else if (resultat)
    {
      lignes.push (this.translocoService.translate ("achat.recherche.completer-pieces-jointes.pieces-ajoutees", {nombre: resultat.nombrePiecesAjoutees}));
      lignes.push (this.translocoService.translate ("achat.recherche.completer-pieces-jointes.types-corriges", {nombre: resultat.nombreTypesCorriges}));

      if (resultat.nombrePiecesAjoutees === 0 && resultat.nombreTypesCorriges === 0)
        lignes.push (this.translocoService.translate ("achat.recherche.completer-pieces-jointes.aucune-piece-manquante"));

      //Sans la table d’attachements de la plateforme agréée, le type des pièces n’est pas fiable :
      //aucun type n’est corrigé dans ce cas, et l’utilisateur doit le savoir.
      if (!resultat.typesFiables)
        lignes.push (this.translocoService.translate ("achat.recherche.completer-pieces-jointes.types-non-corriges"));
    }

    if (resultat && resultat.messages && resultat.messages.length > 0)
    {
      lignes.push (this.translocoService.translate ("achat.recherche.rapport.avertissements"));

      for (const message of resultat.messages)
        lignes.push (`  ${message}`);
    }

    this.lignesRapportImportation = lignes;
  }

  //Formate le raport d’importation
  //  importerFacturesAchatClientResultat : Résultat de l’importation des factures d’achat
  private FormaterRapportImportation (importerFacturesAchatClientResultat: AeFImporterFacturesAchatClientResultat) : void
  {
    let lignesDetails: string[];

    this.lignesRapportImportation =
    [
      this.translocoService.translate ("achat.recherche.importer-factures.nombre-plateformes", {nombre: importerFacturesAchatClientResultat.nombrePA}),
      this.translocoService.translate ("achat.recherche.importer-factures.nombre-factures", {nombre: importerFacturesAchatClientResultat.nombreFacturesPA}),
      this.translocoService.translate ("achat.recherche.importer-factures.nombre-factures-integrees", {nombre: importerFacturesAchatClientResultat.nombreFacturesIntegrees}),
      this.translocoService.translate ("achat.recherche.importer-factures.nombre-erreurs", {nombre: importerFacturesAchatClientResultat.nombreErreurs})
    ];

    for (const detailPA of importerFacturesAchatClientResultat.detailsPA)
    {
      lignesDetails =
      [
        this.translocoService.translate ("achat.recherche.importer-factures.plateforme", {libelle: detailPA.libelle}),
        `  ${this.translocoService.translate ("achat.recherche.importer-factures.nombre-factures", {nombre: detailPA.nombreFactures})}`,
        `  ${this.translocoService.translate ("achat.recherche.importer-factures.nombre-factures-integrees", {nombre: detailPA.nombreFacturesIntegrees})}`
      ];

      if (detailPA.messagesErreurs.length > 0)
      {
        lignesDetails.push (`  ${this.translocoService.translate ("achat.recherche.importer-factures.erreurs")}`);

        for (const messageErreur of detailPA.messagesErreurs)
        {
          lignesDetails.push (`    ${messageErreur}`);
        }
      }

      if (detailPA.messagesAvertissements?.length > 0)
      {
        lignesDetails.push (`  ${this.translocoService.translate ("achat.recherche.rapport.avertissements")}`);

        for (const messageAvertissement of detailPA.messagesAvertissements)
        {
          lignesDetails.push (`    ${messageAvertissement}`);
        }
      }

      this.lignesRapportImportation = this.lignesRapportImportation.concat (lignesDetails);
    }
  }

  //Ferme la boite de dialogue d’affichage du rapport d’importation
  public FermerRapportImportation () : void 
  {
    this.boiteDialogue.fonctionRetour ();
    this.boiteDialogue.Fermer ();
  }

  private async RechercherComplementsComptableBt30 () : Promise<void> 
  {
    let identifiantsFactures: string[];

    identifiantsFactures = this.RetournerIdentifiantsSelectionnees ();

    await this.rechercherComplementComptableBt30.Executer (identifiantsFactures);
  }

  //Retourne les identifiants des factures sélectionnées
  //  Retourne
  //    Identifiants des factures sélectionnées
  private RetournerIdentifiantsSelectionnees () : string[] 
  {
    let identifiantsFactures: string[];

    if (this.grilleRecherche.identifiantsSelectionnes.length > 0)
      identifiantsFactures = this.grilleRecherche.identifiantsSelectionnes;
    else
      if (this.grilleRecherche.identifiantFocus)
        identifiantsFactures = [this.grilleRecherche.identifiantFocus];
      else
        identifiantsFactures = [];

    return identifiantsFactures;
  }

  //Retourne l’identifiant sélectionné
  //  Retourne
  //    Identifiant sélectionné
  private RetournerIdentifiantSelectionne () : string | null
  {
    let identifiant: string | null = null;

    if (this.grilleRecherche.identifiantFocus)
      identifiant = this.grilleRecherche.identifiantFocus;
    else if(this.grilleRecherche.identifiantsSelectionnes.length > 0)
      identifiant = this.grilleRecherche.identifiantsSelectionnes[0];

    return identifiant;
  } 

  //Transfère les documents des factures d’achat vers le back-office (SU #116854)
  //  Porte sur les lignes sélectionnées, à défaut sur la ligne au focus (SU #117296). Le balayage
  //  de toutes les factures éligibles du client reste la voie du job.
  public async TransfererDocumentsFacturesAchat () : Promise<void>
  {
    let valApiResultat: ValApiResultat<AeFTransfererDocumentsFacturesAchatResultat>;

    this.grilleRecherche.operationEnCours = true;

    try
    {
      valApiResultat = await this.eFactTraitementService.TransfererDocumentsFacturesAchat (
                       {
                         identifiantsFactures: this.RetournerIdentifiantsSelectionnees ()
                       });

      await this.RestituerResultatTraitement (c_TitreTransfererDocuments,
                                              "achat.recherche.transferer-documents.bandeau",
                                              valApiResultat.status,
                                              valApiResultat.messages,
                                              valApiResultat.message,
                                              valApiResultat.resultat?.details);
    }
    catch (erreur)
    {
      await this.RestituerErreurTechniqueTraitement (c_TitreTransfererDocuments, erreur);
    }

    this.grilleRecherche.operationEnCours = false;

    //La date de dernier transfert de documents est une colonne de la grille : sans relance de la
    //recherche, elle reste vide sous les yeux de l’utilisateur qui vient de lancer le traitement.
    await this.RafraichirGrilleApresTraitement ();
  }

  //Crée les pièces d’achat des factures d’achat côté back-office (SU #116856)
  //  Porte sur les lignes sélectionnées, à défaut sur la ligne au focus (SU #117296).
  public async CreerPieceAchatFacturesAchat () : Promise<void>
  {
    let valApiResultat: ValApiResultat<AeFCreerPieceAchatFacturesAchatResultat>;

    this.grilleRecherche.operationEnCours = true;

    try
    {
      valApiResultat = await this.eFactTraitementService.CreerPieceAchatFacturesAchat (
                       {
                         identifiantsFactures: this.RetournerIdentifiantsSelectionnees ()
                       });

      await this.RestituerResultatTraitement (c_TitreCreerPieceAchat,
                                              "achat.recherche.creer-piece-achat.bandeau",
                                              valApiResultat.status,
                                              valApiResultat.messages,
                                              valApiResultat.message,
                                              valApiResultat.resultat?.details);
    }
    catch (erreur)
    {
      await this.RestituerErreurTechniqueTraitement (c_TitreCreerPieceAchat, erreur);
    }

    this.grilleRecherche.operationEnCours = false;
  }

  //Rapproche les factures d’achat d’une facture dossier déjà saisie côté back-office (SU #118217)
  //  Porte sur les lignes sélectionnées, à défaut sur la ligne au focus, comme ses deux voisins.
  //  Aucune pièce d’achat n’est créée : une facture sans candidate reste à créer par
  //  « Créer la pièce d’achat ». Le message rendu par le back-office le dit, et il est restitué tel
  //  quel dans les logs — le réinterpréter ici ferait perdre le motif exact du non-rapprochement.
  public async RapprocherFactureDossierFacturesAchat () : Promise<void>
  {
    let valApiResultat: ValApiResultat<AeFRapprocherFactureDossierFacturesAchatResultat>;

    this.grilleRecherche.operationEnCours = true;

    try
    {
      valApiResultat = await this.eFactTraitementService.RapprocherFactureDossierFacturesAchat (
                       {
                         identifiantsFactures: this.RetournerIdentifiantsSelectionnees ()
                       });

      await this.RestituerResultatTraitement (c_TitreRapprocherFactureDossier,
                                              "achat.recherche.rapprocher-facture-dossier.bandeau",
                                              valApiResultat.status,
                                              valApiResultat.messages,
                                              valApiResultat.message,
                                              valApiResultat.resultat?.details);
    }
    catch (erreur)
    {
      await this.RestituerErreurTechniqueTraitement (c_TitreRapprocherFactureDossier, erreur);
    }

    this.grilleRecherche.operationEnCours = false;
  }

  //Active ou désactive les factures d’achat sélectionnées (SU #117315)
  //  Neutralise des lignes du SAS sans les supprimer — le cas d’usage est une réception en double.
  //  La recherche ne filtre pas IDESACTIVE : une facture désactivée reste dans la grille, donc
  //  réactivable par le même traitement.
  public async ActiverDesactiverFacturesAchat () : Promise<void>
  {
    let modifiee: boolean;

    modifiee = await this.activerDesactiverFacturesAchat.Executer (this.RetournerIdentifiantsSelectionnees ());

    //La colonne « Active » de la grille est peuplée par la recherche : sans relance, elle reste sur
    //l’état d’avant le traitement sous les yeux de l’utilisateur qui vient de le lancer.
    if (modifiee)
      await this.RafraichirGrilleApresTraitement ();
  }

  //Marque les factures d’achat sélectionnées « à refuser », ou annule ce marquage (SU #117809)
  //  Le refus lui-même est transmis à la plateforme agréée par le job de refus automatique : ce
  //  traitement ne décide que du marquage, et l’annulation ne porte que tant que le refus n’est pas
  //  parti — le contrôle se fait facture par facture au moment du traitement.
  public async RefuserFacturesAchat () : Promise<void>
  {
    let modifiee: boolean;

    modifiee = await this.refuserFacturesAchat.Executer (this.RetournerIdentifiantsSelectionnees ());

    //Les colonnes « À refuser » et « Date refus automatique » de la grille sont peuplées par la
    //recherche : sans relance, elles restent sur l’état d’avant le traitement.
    if (modifiee)
      await this.RafraichirGrilleApresTraitement ();
  }

  //Envoie les factures d’achat sélectionnées vers une corbeille GED choisie par l’utilisateur (SU #120249)
  //  Pose à la main la destination que le job de marquage pose sinon par règle. Le contrôle de
  //  chaque facture se fait côté serveur, qui écarte nommément celles qu’il ne peut pas affecter.
  public async EnvoyerCorbeilleGedFacturesAchat () : Promise<void>
  {
    let modifiee: boolean;

    modifiee = await this.corbeilleGedFacturesAchat.Envoyer (this.RetournerIdentifiantsSelectionnees ());

    //La colonne « Corbeille GED » de la grille est peuplée par la recherche : sans relance, elle
    //reste sur l’état d’avant le traitement.
    if (modifiee)
      await this.RafraichirGrilleApresTraitement ();
  }

  //Retire la corbeille GED de destination des factures d’achat sélectionnées (SU #120249)
  public async RetirerCorbeilleGedFacturesAchat () : Promise<void>
  {
    let modifiee: boolean;

    modifiee = await this.corbeilleGedFacturesAchat.Retirer (this.RetournerIdentifiantsSelectionnees ());

    if (modifiee)
      await this.RafraichirGrilleApresTraitement ();
  }

  //Calcule ou envoie les statuts de cycle de vie à envoyer des factures d’achat sélectionnées (SU #119400)
  public async TraiterStatutsAEnvoyer () : Promise<void>
  {
    let modifiee: boolean;

    modifiee = await this.statutsAEnvoyerFacturesAchat.Executer (this.RetournerIdentifiantsSelectionnees ());

    //Les onglets « Statuts à envoyer » / « Statuts envoyés » et leur colonne sont peuplés par la
    //recherche : sans relance, la grille reste sur l’état d’avant le traitement.
    if (modifiee)
      await this.RafraichirGrilleApresTraitement ();
  }

  //Restitue le résultat d’un des deux traitements de transfert
  //  Paramètres
  //    cleTitre   : Clé de traduction du titre de la fenêtre — nomme le traitement
  //    cleBandeau : Clé de traduction du texte du bandeau de la fenêtre de logs
  //    status     : Statut du résultat d’API
  //    messages   : Messages du résultat d’API
  //    message    : Message unitaire du résultat d’API
  //    details    : Résultat détaillé par facture
  private async RestituerResultatTraitement (cleTitre: string,
                                             cleBandeau: string,
                                             status: string,
                                             messages: string[] | undefined,
                                             message: string | undefined,
                                             details: DetailTransfertFactureAchat[] | undefined) : Promise<void>
  {
    let messagesErreur: string[];
    let titre: string;

    titre = this.translocoService.translate (cleTitre);

    if (status === "success")
    {
      //Les deux traitements rendent toujours le détail par facture, même quand rien n’a été
      //traité : ne rien ouvrir laisserait l’utilisateur sans réponse.
      if (details && details.length > 0)
        await this.logsTransfertFacturesAchat.Ouvrir (titre, this.translocoService.translate (cleBandeau), details);
      else
      {
        this.boiteDialogueMessages.titre    = titre;
        this.boiteDialogueMessages.icone    = "information.png";
        this.boiteDialogueMessages.messages = [this.translocoService.translate ("achat.recherche.aucune-facture-a-traiter")];

        await this.boiteDialogueMessages.Ouvrir ();
      }

      return;
    }

    messagesErreur = messages && messages.length > 0
      ? messages
      : [message && message.length > 0 ? message : this.translocoService.translate ("achat.recherche.erreur-traitement", {titre: titre})];

    this.boiteDialogueMessages.titre    = titre;
    this.boiteDialogueMessages.icone    = "exclamation.png";
    this.boiteDialogueMessages.messages = messagesErreur;

    await this.boiteDialogueMessages.Ouvrir ();
  }

  //Restitue une erreur technique survenue à l’appel d’un des deux traitements
  //  Paramètres
  //    cleTitre : Clé de traduction du titre de la fenêtre — nomme le traitement
  //    erreur   : Erreur interceptée
  private async RestituerErreurTechniqueTraitement (cleTitre: string, erreur: unknown) : Promise<void>
  {
    let messages: string[];
    let titre: string;

    titre = this.translocoService.translate (cleTitre);

    messages = [this.translocoService.translate ("achat.commun.erreur-technique-traitement", {titre: titre})];

    if (erreur != null && typeof (erreur as { message?: unknown }).message === "string")
      messages.push ((erreur as { message: string }).message);

    this.boiteDialogueMessages.titre    = titre;
    this.boiteDialogueMessages.icone    = "exclamation.png";
    this.boiteDialogueMessages.messages = messages;

    await this.boiteDialogueMessages.Ouvrir ();
  }

  //Relance la recherche pour refléter les dates posées par le traitement
  private async RafraichirGrilleApresTraitement () : Promise<void>
  {
    try
    {
      //ExecuterRecherche est un chargeur paginé qui concatène la page reçue aux données déjà
      //affichées : sans remise à zéro préalable, il redemande la page courante et la duplique.
      this.grilleRecherche.ReinitaliserRecherche ();

      await this.grilleRecherche.ExecuterRecherche ();
    }
    catch (erreur)
    {
      //Le traitement a abouti : l’échec du seul rafraîchissement d’affichage ne doit pas être
      //remonté comme un échec du traitement.
    }
  }

  //Edite la référence de commande d’une facture d’achat
  public async EditerReferenceCommande () : Promise<void> 
  {
    let identifiantFacture: string | null;

    identifiantFacture = this.RetournerIdentifiantSelectionne ();

    if (identifiantFacture && await this.InitialiserEditionReferenceCommande (identifiantFacture))
        await this.OuvrirEditionReferenceCommande (identifiantFacture);
  }

  //Initialise l’édition de la référence de commande
  //  Paramètres
  //    identifiantFacture : Identifiant de la facture
  //  Retourne
  //    Vrai si l’initialisation a réussi
  private async InitialiserEditionReferenceCommande (identifiantFacture: string) : Promise<boolean> 
  {
    let initialisationReussi: boolean;
    let aefInitialiserSaisieRefCommandeFactureAchatParametres: AeFInitialiserSaisieRefCommandeFactureAchatParametres;
    let valApiResultat: ValApiResultat<AeFInitialiserSaisieRefCommandeFactureAchatResultat>;
    let messages: string[];

    initialisationReussi = false;

    aefInitialiserSaisieRefCommandeFactureAchatParametres = new AeFInitialiserSaisieRefCommandeFactureAchatParametres ();
    aefInitialiserSaisieRefCommandeFactureAchatParametres.identifiantFacture = identifiantFacture;

    this.grilleRecherche.operationEnCours = true;

    try
    {
      valApiResultat = await this.eFactTraitementService.InitialiserSaisieRefCommandeFactureAchat (aefInitialiserSaisieRefCommandeFactureAchatParametres);

      if (valApiResultat.status === "success")
      {
        //Le verrou porte sur les deux transferts vers le back-office : les documents
        //(XDATE_TRANSMISSION) et la pièce d’achat (XDATE_CREATION_FACTURE_DOSSIER). L’union est
        //calculée côté serveur, qui refuse aussi l’écriture en direct sur la route.
        if (valApiResultat.resultat!.transfereVersBackOffice)
        {
          messages = [];

          messages.push (this.translocoService.translate ("achat.recherche.reference-commande.saisie-interdite-ligne-1"));
          messages.push (this.translocoService.translate ("achat.recherche.reference-commande.saisie-interdite-ligne-2"));

          await this.AfficherMessageEditionReferenceCommande (messages);
        }
        else
        {
          this.donneesEditionReferenceCommande.referenceCommande = valApiResultat.resultat!.numeroCommande ?? "";
          this.referenceCommande = this.donneesEditionReferenceCommande.referenceCommande;

          initialisationReussi = true;
        }
      }
    }
    catch (erreur)
    {
    }

    this.grilleRecherche.operationEnCours = false;

    return initialisationReussi;
  }

  //Ouvre l’édition de la référence de commande
  //  Paramètres
  //    identifiantFacture : Identifiant de la facture
  private async OuvrirEditionReferenceCommande (identifiantFacture: string) : Promise<void> 
  {
    let aefMettreAJourRefCommandeFactureAchatParametres: AeFMettreAJourRefCommandeFactureAchatParametres;
    let valApiResultat: ValApiResultat<any>;
    let referenceCommandeSaisie: string;

    try
    {
      this.donneesEditionReferenceCommande.valide = false;

      await this.editionReferenceCommande.Ouvrir ();

      if (this.donneesEditionReferenceCommande.valide)
      {
        this.grilleRecherche.operationEnCours = true;

        //Un champ vidé vaut suppression : le serveur normalise en NULL, la grille en chaîne vide.
        referenceCommandeSaisie = this.donneesEditionReferenceCommande.referenceCommande.trim ();

        aefMettreAJourRefCommandeFactureAchatParametres = new AeFMettreAJourRefCommandeFactureAchatParametres ();
        aefMettreAJourRefCommandeFactureAchatParametres.identifiantFacture = identifiantFacture;
        aefMettreAJourRefCommandeFactureAchatParametres.numeroCommande = referenceCommandeSaisie;

        valApiResultat = await this.eFactTraitementService.MettreAJourRefCommandeFactureAchat (aefMettreAJourRefCommandeFactureAchatParametres);

        if (valApiResultat.status === "success")
          this.grilleRecherche.donneesGrille.find (fac => fac.PK === identifiantFacture).REF_COMMANDE = referenceCommandeSaisie;
        else
          await this.AfficherMessageEditionReferenceCommande ([valApiResultat.message]);
      }
    }
    catch (erreur)
    {
    }

    this.grilleRecherche.operationEnCours = false;
  }

  //Affiche un message sur l’édition de la référence de commande
  //  Paramètres
  //    messages : Messages à afficher
  private async AfficherMessageEditionReferenceCommande (messages: string[]) : Promise<void>
  {
    this.boiteDialogueMessages.titre = this.translocoService.translate ("achat.recherche.reference-commande.titre");
    this.boiteDialogueMessages.icone = "exclamation.png";
    this.boiteDialogueMessages.messages = messages;

    await this.boiteDialogueMessages.Ouvrir ();
  }

  //Valide l’édition de la référence de commande
  public ValiderEditionReferenceCommande () : void
  {
    this.donneesEditionReferenceCommande.valide = true;
    this.editionReferenceCommande.fonctionRetour (this.donneesEditionReferenceCommande);
    this.editionReferenceCommande.Fermer ();
  }

  //Annule l’édition de la référence de commande
  public AnnulerEditionReferenceCommande () : void 
  {
    this.donneesEditionReferenceCommande.valide = false;
    this.editionReferenceCommande.fonctionRetour (this.donneesEditionReferenceCommande);
    this.editionReferenceCommande.Fermer ();
  }

  //Ouvre la boîte de dialogue de sélection du statut
  private async OuvrirSelectionStatut () : Promise<void> 
  {
    let identifiantsFactures: string[];

    identifiantsFactures = this.RetournerIdentifiantsSelectionnees ();

    await this.mettreAJourStatutFacturesAchat.Executer (identifiantsFactures);
  }

  //Synchronise les cycles de vies
  private async SynchroniserCyclesVies () : Promise<void> 
  {
    let identifiantsFactures: string[];

    identifiantsFactures = this.RetournerIdentifiantsSelectionnees ();

    await this.synchroniserCyclesViesFacturesAchat.Executer (identifiantsFactures);
  }

  //Rapproche les commandes
  private async RapprocherCommandesFacturesAchat () : Promise<void> 
  {
    let identifiantsFactures: string[];
    let commandesFactures: AeFCommandeFacture[];

    identifiantsFactures = this.RetournerIdentifiantsSelectionnees ();

    commandesFactures = await this.rapprocherCommandeFacturesAchat.Executer (identifiantsFactures);

    if (commandesFactures.length > 0)
    {
      if (this.grilleRecherche.colonnes.find (col => col.champ === "REF_COMMANDE" && col.visible))
      {
        for (let commandeFacture of commandesFactures)
          this.grilleRecherche.donneesGrille.find (fac => fac.PK === commandeFacture.identifiantFacture).REF_COMMANDE = commandeFacture.referenceCommande;
      }
    }
  }
}

//Représente les données d’édition de la référence de commande
export class DonneesEditionReferenceCommande 
{
  //Création
  constructor () 
  {
    this.referenceCommande = "";
    this.valide = false;
  }

  //Référence de commande
  public referenceCommande: string;

  //Indique si validé
  public valide: boolean;
}
